import { memo, useMemo } from "react";
import { useApp } from "./context/AppContext";

import AboutMe from "./components/Modal/AboutMe";
import QuestModal from "./components/Modal/QuestModal";
import RegistryEditor from "./components/Modal/Registry";
import NetworkStatus from "./components/Modal/NetworkStatus";
import ChatClient from "./components/Modal/ChatClient";
import MailClient from "./components/Modal/MailClient";
import AboutProjects from "./components/Modal/AboutProjects";
import WebAmp from "./components/Modal/WebAmp";
import RunDialog from "./components/Modal/RunDialog";
import InternetClient from "./components/Modal/InternetClient";
import ComputerProperties from "./components/Modal/SystemProperties";
import UserInfo from "./components/Modal/UserInfo";

export default memo(function AppModals() {
  const { getInternetClientInstances } = useApp();

  // get all internet client instances
  const internetClientInstances = useMemo(() => {
    const instances = Array.from(getInternetClientInstances().entries());
    return instances;
  }, [getInternetClientInstances]);

  return (
    <>
      <AboutMe />
      <QuestModal />
      <RegistryEditor />
      <NetworkStatus />
      <ChatClient />
      <MailClient />
      <RunDialog />
      <UserInfo />
      <ComputerProperties />

      {/* <AboutProjects /> */}
      {/* <WebAmp /> */}

      {/* render default internet client (starts closed) */}
      <InternetClient
        instanceId="InternetClient"
        defaultClosed={true}
      />

      {/* render additional internet client instances (start open) */}
      {internetClientInstances.map(([instanceId, data]) => (
        <InternetClient
          key={instanceId}
          instanceId={instanceId}
          initialURL={data?.initialURL}
          defaultClosed={false}
        />
      ))}


    </>
  );
});
